namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class DetailCertifikacniAutorita extends GContentBase {
        private dataListDescription: Gordic.General.ApplicationInterface.GDataListDescription;
        private data: Gordic.AdmIsl.Interface.GCertifikacniAutoritaReadDto;
        private newRecord: boolean;
        private detailObj: DetailCertifikacniAutoritaObj & GContent;

        // hodnota parametru adx_checkiconad 
        private currentFilter: any;
        private gridRc: Gordic.Components.GridRC<any>;
        private createPreviousAndNextAction: boolean;

        onDetailBuilderInit(builder: Gordic.Gin.DetailBuilder.GDetailBuilder) {
            this.detailObj = $.extend(this, new DetailCertifikacniAutoritaObj());
            this.detailObj.createBase({
                contentName: "detailCertifikacniAutorita",
                contentCaption: "jres:29809454",
                newRecord: this.newRecord,
                data: this.data,
                dataListDescription: this.dataListDescription,
                addPlatnost: false,
                currentFilter: this.currentFilter,
                gridRc: this.gridRc,
                createPreviousAndNextAction: this.createPreviousAndNextAction,
            });
            var tabs: Gordic.Gin.DetailBuilder.TabParamsId[] | ObjectLiteral<Gordic.Gin.DetailBuilder.TabParams> | null = [];
            if (this.newRecord == false)
                tabs.push(this.detailObj.getAuditPristupuTab());
            var groups: IGTabGroupOptions[] = [];
            if (this.newRecord == false)
                groups.push(this.detailObj.getAuditPristupuGroup());
            builder.withComponent<this>("DetailCertifikacniAutorita", {
                statusBar: this.detailObj.createStatusBar(),
                menuBar: this.detailObj.createMenuBar(),
                headerForm: this.detailObj.createFormComplet(),
                commandBar: this.detailObj.createCommandBar(),
                sidePanels: [/*this.detailObj.getAuditPristupu(),*/ this.detailObj.getPoznamky()],
                tabs: tabs,
                tabGroups: groups,
            })
        }

        onContentReady() {
            this.detailObj.finishBuilder()
        }

        closing() {
            return this.detailObj.closeAction();
        }
    }


    export class DetailCertifikacniAutoritaObj extends GAdmDetailBase<Gordic.AdmIsl.Interface.GCertifikacniAutoritaReadDto> {

        create() {

        }

        textPopis(): string | undefined | null {
            return this.data["stat_txt"]
        }

        setSxsDetail(): string {
            return (this.data.stat) ? this.data.stat.toString() : "";
        }

        saveData(data: Gordic.AdmIsl.Interface.GCertifikacniAutoritaSaveDto, close: boolean) {
            
        }

        reloadData(filterObj: any, dataObj: any) {
            $.content().navigate(["Gordic.Adm.WebControls.DetailCertifikacniAutorita", filterObj], dataObj);
        }

        updateGrid(filter: any, grid: any): any {
            return this.cnt.isl.CertifikacniAutorita.list({
                filters: filter
            }).getView().promise()
        }

        createTitle(): string {
            if (this.options.newRecord == true)
                return "jres:32000121";
            return "{0} - {1}".format(this.options.contentCaption, (this.data.jmeno) ? this.data.jmeno : "");
        }

        createMenuBar(): Gordic.Gin.DetailBuilder.GDetailBuilderMenuItemDef {
            return [
                 "actExportCert*",
                { action: this.cnt.actions.actPrevious, favorite: true, align: "opposite" },
                { action: this.cnt.actions.actNext, favorite: true, align: "opposite" }
            ]
        }

        createCommandBar(): Gordic.Gin.DetailBuilder.GDetailBuilderMenuItemDef {
            return [
                "actClose*"
            ]
        }

        createActions(): { [akceName: string]: GAction | GActionParamsDefObj } | null { 
            return {
                actExportCert: {
                    icon: "fa-download",
                    caption: "jres:33000047", //RC 33000047 : Export CER souboru
                    run: () => {
                        this.exportCertificate();
                    }
                }
            }
        }

        setEditMode(editMode: boolean) {

        }

        createForm() {
            this.form.form.layoutDescriptor = "L1M1S1";
            this.form.addRow(this.getCaption("ixs_cau")).addField("gstaticfield", { name: "ixs_cau" })
            this.form.addRow(this.getCaption("jmeno")).addField("gstaticfield", { name: "jmeno" })
            this.form.addRow(this.getCaption("dat_od")).addField("gstaticfield", {
                name: "dat_od",
                modelValueTransform: {
                    apply: (fieldValue) => { return Gordic.Templates.Formatters.date(fieldValue) }
                }
            })
            this.form.addRow(this.getCaption("dat_do")).addField("gstaticfield", {
                name: "dat_do",
                modelValueTransform: {
                    apply: (fieldValue) => { return Gordic.Templates.Formatters.date(fieldValue) }
                }
            })
            this.form.addRow(this.getCaption("stat")).addField("gstaticfield", { name: "stat" })
            this.form.addRow(this.getCaption("ulice")).addField("gstaticfield", { name: "ulice" })
            this.form.addRow(this.getCaption("obec")).addField("gstaticfield", { name: "obec" })
            this.form.addRow(this.getCaption("firma")).addField("gstaticfield", { name: "firma" })
            this.form.addRow(this.getCaption("utvar")).addField("gstaticfield", { name: "utvar" })
            this.form.addRow(this.getCaption("adresa")).addField("gstaticfield", { name: "adresa" })
            this.form.addRow(this.getCaption("tel")).addField("gstaticfield", { name: "tel" })
            this.form.addRow(this.getCaption("email")).addField("gstaticfield", { name: "email" })
            this.form.addRow(this.getCaption("id_cert")).addField("gstaticfield", { name: "id_cert" })
            this.form.addRow(this.getCaption("otisk")).addField("gstaticfield", { name: "otisk" })
            this.form.addRow(this.getCaption("typ_cert")).addField("gstaticfield", { name: "typ_cert" })
            this.form.addRow(this.getCaption("status")).addField("gstaticfield", { name: "status" })
            this.form.addRow(this.getCaption("ixs_cau_nad")).addField("gstaticfield", { name: "ixs_cau_nad_txt" })
            this.form.addRow(this.getCaption("priz_akr")).addField("gstaticfield", { name: "priz_akr_txt" })
            this.form.addRow(this.getCaption("priz_eu_tsl")).addField("gstaticfield", { name: "priz_eu_tsl_txt" })
            this.form.addRow(this.getCaption("poznamka")).addField("gstaticfield", { name: "poznamka" })
            this.form.addRow(this.getCaption("aktivita")).addField("gstaticfield", { name: "aktivita_txt" })
            this.form.addRow(this.getCaption("dat_zmena")).addField("gstaticfield", {
                name: "dat_zmena",
                modelValueTransform: {
                    apply: (fieldValue) => { return Gordic.Templates.Formatters.datetime(fieldValue) }
                }
            })
            this.form.addRow(this.getCaption("zmenu_prov")).addField("gstaticfield", { name: "zmenu_prov_txt" })
        }

        private getCaption(name: string): string {
            var result = this.metadata.detail_fields?.[name].field_caption;
            return result != null && result != undefined ? result : "";
        }

        private exportCertificate() {
            this.cnt.dialogs.showModalWindow(["Gordic.Adm.WebControls.DialogExportCertifikacniAutorita", {
                fileContent: this.data.file_content,
                fileType: this.data.typ_souboru_cert,
                defaultName: "{0}-{1}".format(this.data.id_cert ? this.data.id_cert : "", this.data.jmeno ? this.data.jmeno : "certificate"),
            }], null, { width: 500, height: 230 });
        }
    }
}